module.exports = __webpack_public_path__ + "img/widget.e4b9196b.svg";